<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Assignment Retur  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:120px !important;">Retur Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col  lg="5">
            <b-input-group >
              <b-input-group-prepend><label style="width:90px !important;">Description</label></b-input-group-prepend>
              <b-form-input v-model="tblData.assignmentname" placeholder="Assignment Description" ></b-form-input>
                <b-input-group-append><b-button class="btn btn-success ml-1" style="width:110px !important;" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append><b-button class="btn btn-secondary ml-1" style="width:110px !important;" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
        class="mb-0"
            ref="tblAssignment"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
        <template v-slot:cell(returdate)="data">
          {{ data.item.returdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(startdate)="data">
          {{ data.item.startdate | moment("DD MMM YYYY") }} - {{ data.item.duedate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(modified)="data">
          <span v-if="(data.item.modified)">
          {{ data.item.modified | moment("DD MMM YYYY") }}
          </span>
        </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <b-modal v-model="showFrm" header-bg-variant="primary" size="lg" title="Form - Assignment Retur" :centered="true" @ok="save" ok-title="Save">
        <b-row >
          <b-col>
            <b-input-group>
              <b-input-group-prepend>
                <label style="width:140px;">Retur Order Date</label>
              </b-input-group-prepend>
              <b-input type="date" v-model="frmdata.returdate" :state="!$v.frmdata.returdate.$error" @change="returdateChange(frmdata.returdate)" />
              <b-input-group-prepend><span class="pt-2 pl-2" style="width:140px;">Assigned To</span></b-input-group-prepend>
              <b-form-input v-model="frmdata.employee_name" placeholder="User Name" @change="userChange"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuUserShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>

            <b-input-group >
              <b-input-group-prepend><label style="width:140px;">Description</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.assignmentname" placeholder="Assignment Description" :state="!$v.frmdata.assignmentname.$error"></b-form-input>
            </b-input-group >

            <b-input-group >
              <b-input-group-prepend><label style="width:140px !important;">Periode</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.startdate" :state="!$v.frmdata.startdate.$error" type="date" id="startdate" disabled ></b-form-input>
              <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
              <b-form-input v-model="frmdata.duedate" :state="!$v.frmdata.duedate.$error" :min="frmdata.startdate" type="date" id="duedate" 
              :disabled="frmdata.startdate==''" ></b-form-input>
            </b-input-group>

            

          </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of User" :centered="true">
        <lku-user @click="onSelectLkuUser"></lku-user>
    </b-modal> 

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>       

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import retur from "../../apis/bakeryreturcustomer";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuUser from "../lookup/lkuUser";
toastr.init();

export default {
  components :{Loading, lkuUser},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            returdate: { required },
            assignmentname: { required},
            startdate: { required },
            duedate: { required },
            userid: { required },
            username: { required },
            employee_name: { required },
        },
  },   
  data() {
    return {
      fields: [
          {
            key: "returdate",
            label: "Retur Date",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "employee_name",
            label: "Assigned To",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "assignmentname",
            label: "Description",
            sortable: true
          },
          {
            key: "startdate",
            label: "Periode",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "modified",
            label: "Issued Date",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "createby",
            label: "Issued By",
            thStyle: "width:150px",
            sortable: true
          },
      ],
      //maxdtreport : moment(this.$store.state.timeServer).subtract(1,'days').format('YYYY-MM-DD'),
      //this.model.returdate ? moment(this.model.returdate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD");
      // minperiode : moment(this.frmdata.returdate).add(5,'days').format('YYYY-MM-DD'),
      //minperiode : moment().format("YYYY-MM-DD"),
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      limit:15,
      pagination: false,
      model:{},showFrm:false,
      frmdata: {returdate:'',startdate:'',duedate:''},
      lkuUserShow:false,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
    };
  },
  
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },

  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },     
  },

  methods: {
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.returlist) {
            this.tblData[key] = filter.returlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.returlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.returlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=false; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await retur.assignment(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }
        } else {
            this.isLoading=true;
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            try {
              const list = await retur.assignment(this.tblData);
              this.pagination=true;
              this.isLoading=false;  
              return list;        
            } catch (error) {
              this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
            }
        }
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },

    returdateChange: function (val) {
        if(val!=''){
          let startdate = moment(val).add(2,'days').format('YYYY-MM-DD');
          this.frmdata.startdate = startdate;
          this.frmdata.duedate = startdate;
        }
    },

    refresh() {
      this.$refs.tblAssignment.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.tgl1 = '';
        this.tblData.tgl2 =  '';
        this.tblData.assignmentname = '';
        this.tblData.userid = '';
        this.tblData.username = '';
        this.tblData.employee_name = '';
        this.refresh();
    },       
    saveFilter() {
      const keys = ['tgl1', 'tgl2','assignmentname','employee_name'];
      let filtered = false;
      const returlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              returlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          returlist.page=this.tblData.page;
          returlist.limit=this.tblData.limit;
          returlist.sortBy=this.tblData.sortBy;
          returlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.returlist=returlist;
          this.$store.commit("filter", filter);
      }
    },

    userChange: function () {
        this.frmdata.userid = '';
        this.frmdata.username = '';
        this.frmdata.employee_name = '';
    },

    add: function(data) {
          this.frmdata.returdate= '';
          this.frmdata.startdate= '';
          this.frmdata.duedate= '';
          this.frmdata.assignmentname= '';
          this.frmdata.userid= '';
          this.frmdata.username= '';
          this.frmdata.employee_name= '';
          this.frmdata.assignmentkey= '';
          this.showFrm=true;
    },

    edit: function() {
        if (this.model.assignmentkey) {
          this.frmdata.assignmentkey= this.model.assignmentkey;
          this.frmdata.assignmentname= this.model.assignmentname;
          this.frmdata.returdate = this.model.returdate ? moment(this.model.returdate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD");
          this.frmdata.startdate = this.model.startdate ? moment(this.model.startdate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD");
          this.frmdata.duedate = this.model.duedate ? moment(this.model.duedate).format('YYYY-MM-DD') : moment().format("YYYY-MM-DD");
          this.frmdata.userid= this.model.userid;
          this.frmdata.username= this.model.username;
          this.frmdata.employee_name= this.model.employee_name;
          this.showFrm=true;
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },

    onSelectLkuUser: async function (_selected) {
        this.frmdata.userid = _selected.user_id;
        this.frmdata.username = _selected.username;
        this.frmdata.employee_name = _selected.full_name.trim();
        this.lkuUserShow=false;
    }, 

    save: async function(evt) {
      evt.preventDefault()
      if (this.invalidFrmdata) {
          console.log('validation : ', this.$v.frmdata);
          console.log('frmdata obj : ',this.frmdata);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        try {
          this.showFrm = false;
          await retur.saveassignment(this.frmdata);
          this.refresh();          
        } catch (error) {
          this.showFrm = true;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }            
        }
      }
    },

    deleteConfirm() {
        if (this.model.assignmentkey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },

    deleteData: async function() {
      try {
        this.isLoading=true;
        await retur.removeassignment(this.model);
      this.refresh();
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await retur.exportassignmentxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
